// this file exists so that other files can easily get a mock geocoder object
export const getGeocoder = (googleMapsObject): google.maps.Geocoder => new googleMapsObject.maps.Geocoder();
